import Icon from '@/atoms/Icon'
import useFrozenBody from '@/hooks/useFrozenBody'
import Footer from '@/organisms/Footer'
import Motion from '@/organisms/Motion'
import useModalStore from '@/store/slices/modal'

import Modals from './includes/Modals'

function Checkout({ children }: Template) {
  const { name } = useModalStore()
  const freezed = typeof name === 'string'

  useFrozenBody(freezed)

  return (
    <Motion
      className="flex flex-col flex-grow h-full"
      transition={{ delay: 0.2 }}
    >
      <Modals />
      <nav className="py-4 bg-[#32C5BA] relative z-10">
        <div className="box">
          <Icon name="logo" className="block w-24 text-white mb-0.5 lg:mb-1" />
        </div>
      </nav>
      <div className="flex-grow w-full my-8">{children}</div>
      <Footer onlyBar />
    </Motion>
  )
}

export default Checkout
